import React from 'react';
import Select from 'react-select';
/* This component is used in
components/pages/comparison/comparisoncard/index.jsx
components/pages/overview/searchcontainer.jsx
containers/toolbar.jsx
*/
const constructOptions = (tree, options) => {
    if (tree.type !== 'customer') {
        options.push({ label: tree.info.name, values: tree });
    }
    if (tree.children && tree.type !== 'meeting_room' && tree.type !== 'open_area') {
        tree.children.forEach(function (element) {
            if (element.type !== "sensor") {
                constructOptions(element, options);
            }
        });
    }

}
const SearchBarDropDown = (props) => {
    var options = [];
    constructOptions(props.tree, options);

    return (
        <Select
            options={options}
            onBlurResetsInput={true}
            onSelectResetsInput={true}
            onChange={(val) => { props.onChange(val.values) }}
            onOpen={props.onOpen}
            onFocus={props.onFocus}
            onClose={props.onClose}
            placeholder="Search..."
            value={props.value}
            clearable={false}
            openOnFocus={true}
            openOnClick={true}
        />

    );
}

export default SearchBarDropDown


// WEBPACK FOOTER //
// ./src/components/common/searchbardropdown.jsx